import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './containers/Root/Root';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.css';
// rsuite styles are imported per component rather than via the ~660 KB
// `rsuite-default.css` monolith, which shipped the whole library's CSS to every
// page. Kept here (not in the consuming components) so the cascade order stays
// bootstrap -> rsuite -> main.scss: main.scss carries `.rs-*` overrides that
// must continue to load last. Add a line here when a new rsuite component is used.
import 'rsuite/lib/Cascader/styles';
import 'rsuite/lib/CheckTree/styles';
import 'rsuite/lib/Checkbox/styles';
import 'rsuite/lib/CheckboxGroup/styles';
import 'rsuite/lib/DatePicker/styles';
import 'rsuite/lib/List/styles';
import 'rsuite/lib/Loader/styles';
import 'rsuite/lib/Radio/styles';
import 'rsuite/lib/RangeSlider/styles';
import 'rsuite/lib/SelectPicker/styles';
import 'rsuite/lib/Slider/styles';
import 'rsuite/lib/Steps/styles';
import './theme/main.scss';

import { sentryInit } from './utils/sentry';
import { ErrorBoundary } from './utils/ErrorBoundary';
import { initTranslations } from './translations/translations';
import { initLogger } from './core/logger/Logger';

initLogger();
sentryInit();
initTranslations();

ReactDOM.render(
  <ErrorBoundary>
    <Root />
  </ErrorBoundary>,
  document.getElementById('root')
);

// PWA support is deliberately off (see the note in public/index.html). This
// stays as `unregister()` rather than being deleted: it is the kill switch that
// removes a service worker from a browser that installed one previously —
// deleting the call would leave any such worker in place, serving its cached
// bundle indefinitely. Flipping to `register()` is step 5 of
// PWA-READINESS-PLAN.md, not something to do casually.
serviceWorker.unregister();
